(function () {
  function initProductRecommendSlider(section) {
    if (!section || section.dataset.mcPrsReady === 'true') return;

    var track = section.querySelector('.mc-prs__track');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.mc-prs-card'));
    var prev = section.querySelector('.mc-prs__arrow--prev');
    var next = section.querySelector('.mc-prs__arrow--next');
    var dotsWrap = section.querySelector('.mc-prs__dots');

    if (!track || !cards.length) return;
    section.dataset.mcPrsReady = 'true';

    var currentIndex = 0;

    function visibleCards() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 850) return 2;
      if (window.innerWidth <= 1100) return 3;
      return 4;
    }

    function maxIndex() {
      return Math.max(cards.length - visibleCards(), 0);
    }

    function goTo(index) {
      var max = maxIndex();
      currentIndex = Math.max(0, Math.min(index, max));
      var target = cards[currentIndex];
      if (!target) return;

      track.scrollTo({
        left: target.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
      updateDots();
    }

    function nextSlide() {
      if (currentIndex >= maxIndex()) {
        goTo(0);
      } else {
        goTo(currentIndex + 1);
      }
    }

    function prevSlide() {
      if (currentIndex <= 0) {
        goTo(maxIndex());
      } else {
        goTo(currentIndex - 1);
      }
    }

    function createDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var total = maxIndex() + 1;
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mc-prs__dot';
        dot.setAttribute('aria-label', 'Go to product group ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            goTo(index);
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.mc-prs__dot'));
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    }

    if (prev) prev.addEventListener('click', prevSlide);
    if (next) next.addEventListener('click', nextSlide);

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var closest = cards[0];
        cards.forEach(function (card) {
          if (Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(closest.offsetLeft - track.scrollLeft)) {
            closest = card;
          }
        });
        var index = cards.indexOf(closest);
        currentIndex = Math.min(Math.max(index, 0), maxIndex());
        updateDots();
      }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      createDots();
      goTo(currentIndex);
    });

    createDots();
  }

  function initAll() {
    document.querySelectorAll('.mc-prs').forEach(initProductRecommendSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initProductRecommendSlider(event.target.querySelector('.mc-prs'));
  });
})();
